
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          inputCountry: this.querySelector('input[name="country_code"]'),
          inputLangauge: this.querySelector('input[name="language_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };

        this.querySelector('[type=submit]').addEventListener('click', this.onItemClick.bind(this));
      }

      onItemClick(event) {
        event.preventDefault();

        const form = this.querySelector('form');
        
        this.elements.inputCountry.value = this.querySelector('.select-country').value;
        this.elements.inputLangauge.value = this.querySelector('.select-language').value;
        if (form) form.submit();
      }

    }
  );
}